import { render, staticRenderFns } from "./DeviceOrientationMessage.vue?vue&type=template&id=9fb1fc10&scoped=true&"
import script from "./DeviceOrientationMessage.vue?vue&type=script&lang=ts&"
export * from "./DeviceOrientationMessage.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceOrientationMessage.vue?vue&type=style&index=0&id=9fb1fc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb1fc10",
  null
  
)

export default component.exports